export const ConfigParams = Object.freeze({
//   API_URL: 'http://localhost/',
  INDEX_KEY: '$5INzGz|7LoUlj!)pvTO9Ur[Oz[0}',
  // API_URL: 'http://200.10.100.100:8080/',
  API_URL: 'https://gpsapi.ingenea.com.ar/',
//   API_REP_URL: 'http://200.10.100.142/'
  API_REP_URL: 'https://reportes.ingeo.ingenea.com.ar/'
})
